// In src/firebaseInit.js
import { app, auth, db, functions } from "./firebaseConfig";
import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectFunctionsEmulator } from "firebase/functions";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  getToken,
} from "firebase/app-check";

export const initializeFirebase = () => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
  const currentDomain = window.location.hostname;

  console.log("=== Firebase Initialization Debug ===");
  console.log("Environment:", process.env.REACT_APP_FIREBASE_PROJECT_ID);
  console.log("Current domain:", currentDomain);
  console.log("Origin:", window.location.origin);
  console.log("Site key (first 20 chars):", siteKey?.substring(0, 20) + "...");
  console.log("API Key exists:", !!process.env.REACT_APP_FIREBASE_API_KEY);
  console.log("App ID exists:", !!process.env.REACT_APP_FIREBASE_APP_ID);
  console.log("Using PRODUCTION reCAPTCHA Enterprise (no debug mode)");
  console.log("=====================================");

  if (!siteKey) {
    throw new Error(
      "❌ Missing REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY. Check your .env.test / .env.production files."
    );
  }

  // NO DEBUG MODE - Always use real reCAPTCHA Enterprise
  console.log(
    "%c🔒 PRODUCTION MODE: Using reCAPTCHA Enterprise for App Check",
    "color: blue; font-weight: bold"
  );

  // Initialize App Check with reCAPTCHA Enterprise
  let appCheck;
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    console.log("✅ App Check initialized successfully");
  } catch (error) {
    console.error("❌ App Check initialization failed:", error);
    throw error;
  }

  // Test token fetch
  getToken(appCheck, true)
    .then((tokenResult) => {
      console.log(
        "%c✅ AppCheck token obtained successfully from reCAPTCHA Enterprise",
        "color: green; font-weight: bold"
      );
      console.log(
        "   Token preview:",
        tokenResult.token?.substring(0, 20) + "..."
      );
    })
    .catch((error) => {
      console.error(
        "%c❌ AppCheck token fetch FAILED",
        "color: red; font-weight: bold"
      );
      console.error("   Error code:", error.code);
      console.error("   Error message:", error.message);
      console.error("   Full error:", error);

      if (error.code === "app-check/fetch-status-error") {
        console.error("\n🔧 TROUBLESHOOTING:");
        console.error(
          "1. Verify '" + currentDomain + "' is in reCAPTCHA Enterprise domains"
        );
        console.error(
          "2. Check Firebase App Check is configured with correct key"
        );
        console.error(
          "3. Verify reCAPTCHA Enterprise key is 'Score based' type"
        );
        console.error("4. Check browser console for reCAPTCHA errors");
      }
    });

  // Emulators (only for localhost with emulator flag)
  if (
    currentDomain === "localhost" &&
    process.env.REACT_APP_USE_EMULATORS === "true"
  ) {
    console.log("🔧 Local development: Connecting to Firebase emulators...");
    connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(db, "localhost", 8080);
    connectFunctionsEmulator(functions, "localhost", 5001);
  } else {
    console.log("🌐 Connecting to LIVE Firebase services.");
  }

  return appCheck;
};
